/****************************
*   
*   Pantomime Paty (c) 2022
*
*   Author: Oliver Borner 
*   oliverborner@gmail.com
*
*****************************/

<template>

    <div id="app">

        <!-- Preloader -->
        <div v-if="this.preloader">
            <p>Preloader Animation</p>
        </div>

        <div class="container-fluid m-auto" v-if="!this.preloader">
            
            <!-- Loading Game Data -->
            <game-data ref="gameDataComponent"></game-data>

            <!--  Navigation Header -->
            <div class="pantomime-navbar" :class="[isActive ? 'show' : 'hidden']">
                
                <!-- Scores -->
                <div class="float-left">
                    <span class="score-counter">

                        <span v-if="isProUser">
                            <b-icon-bar-chart-fill scale="1.5" class="score-space"></b-icon-bar-chart-fill>
                            <b-icon-hexagon-fill scale="1.5" class="score-space"></b-icon-hexagon-fill>
                            <span class="team-number">2</span>
                        </span>

                        <span v-if="!isProUser">
                            <b-icon-star scale="1.5" class="score-space"></b-icon-star>
                        </span>

                        {{ score + currentScore }}<span class="thin">/</span>{{ seenData.length }}
                    </span>
                </div>
                
                <!-- Zeitanzeige -->
                <div class="float-center"><span class="clock">{{ minutes }}</span></div>

                <div class="float-right right-menu">

                    <span @click="showWords = !showWords; playSound('sounds/slide.mp3')">
                        <b-icon-eye-slash-fill v-if="!showWords" class="icon-space" scale="1.5"></b-icon-eye-slash-fill>
                        <b-icon-eye-fill v-if="showWords" class="icon-space" scale="1.5"></b-icon-eye-fill>
                    </span>

                    <b-icon-volume-up scale="1.5" class="iconfocus" v-if="hasSound" @click="hasSound = !hasSound; playSound('sounds/click3.mp3')"></b-icon-volume-up>
                    <b-icon-volume-mute scale="1.5" class="iconfocus" v-else @click="hasSound = !hasSound; playSound('sounds/click3.mp3')"></b-icon-volume-mute>

                    <span @click="modalMainMenu = !modalMainMenu; playSound('sounds/click3.mp3')"><b-icon-house scale="1.5" class="icon-space-right"></b-icon-house></span>

                </div>

            </div>

            <!-- Progress Bar -->
            <div class="progress my-3" :class="[isActive ? 'show' : 'hidden']">     
                <div class="progress-bar" ref="elaspedTime" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                    {{ minutes }} Sekunden
                </div>
            </div>

            <!-- WORDLIST -->
            <div v-if="loaded" class="words-container">
                                    
                <div id="wordsout" class="cards-list">

                    <div id="firstword" class="slide-in-left mt-2 mb-3">
                        <div @click="checked = !checked; playSound('sounds/wordclick2.mp3')" :class="[!checked ? 'wordcard': 'wordcard-checked']">
                            <span v-if="showWords">{{ currentItems[0] }}
                                <b-icon-check scale="1.5" class="white"></b-icon-check>
                            </span>
                        </div>
                    </div>

                    <div id="secondword" class="slide-in-right mb-3">
                        <div @click="checked2 = !checked2; playSound('sounds/wordclick2.mp3')" :class="[!checked2 ? 'wordcard': 'wordcard-checked']"> 
                            <span v-if="showWords">{{ currentItems[1] }}
                                <b-icon-check scale="1.5" class="white"></b-icon-check>
                            </span>
                        </div>
                    </div>

                    <div id="thirdword" class="slide-in-bottom">
                        <div @click="checked3 = !checked3; playSound('sounds/wordclick2.mp3')" :class="[!checked3 ? 'wordcard': 'wordcard-checked']">
                            <span v-if="showWords">{{ currentItems[2] }}
                                <b-icon-check scale="1.5" class="white"></b-icon-check>                     
                            </span>
                        </div>
                    </div>
        
                </div>
                
                <!-- MODAL - Hauptmenü -->
                <transition name="fade">
                    <div id="p-modal" v-if="modalMainMenu">
                        <div class="settings-menu">
                            <div class="hero-card-img">
                                <img src="./assets/images/logo/default.svg" class="slide-top" width="55px">
                            </div>
                            <p class="settings-entry-heading text-center pt-3">Zurück zum Hauptmenü ?</p>

                            <button type="button" class="btn btn-danger center w-100 mt-4" @click="backToMainMenu(); playSound('sounds/click3.mp3')">OK</button>

                        <div class="close-menu">
                                <b-icon-x scale="1.5" @click="modalMainMenu = false; playSound('sounds/click3.mp3')"></b-icon-x>
                            </div>
                        </div>
                    </div>
                </transition>

                <!-- MODAL - Ende -->
                <transition name="fade">
                    <div id="p-modal" v-if="modalEnde">
                        <div class="settings-menu">
                            <div class="hero-card-img">
                                <img src="./assets/images/logo/default.svg" class="slide-top" width="55px">
                            </div>
                            <p class="settings-entry-heading text-center pt-1">Alle Wörter durchgespielt. Füge weitere Kategorien hinzu.</p>

                            <button type="button" class="btn btn-danger center w-100 mt-4" @click="backToMainMenu()">OK</button>

                        </div>
                    </div>
                </transition>

                <!-- MODAL - GameStart -->
                <transition name="fade">
                    <div id="p-modal" v-if="modalGameStart">
                        
                        <div id="timeend" class="blink_me">
                            
                            <div class="radial_stripes"></div>

                            <span class="hand_img">
                                <transition name="fade">
                                    <img v-if="hand1" src="./assets/images/anim/hand1.svg" class="hand-logo">
                                </transition>
                            </span>

                            <span class="hand_img">
                                <transition name="fade">
                                    <img v-if="hand2" src="./assets/images/anim/hand2.svg" class="hand-logo">
                                </transition>
                            </span>

                            <span class="hand_img">
                                <transition name="fade">
                                    <img v-if="hand3" src="./assets/images/anim/hand3.svg" class="hand-logo">
                                </transition>
                            </span>
                                
                        </div>      

                    </div>   
                </transition>
                
                <!-- Zeit abgelaufen -->
                <transition name="fade">
                    <div v-if="timeend" @click="timeend = !timeend; playSound('sounds/click3.mp3')" id="p-modal">
                        <div id="timeend" class="blink_me">
                            <div class="radial_stripes"></div>
                            <span class="ende_runde">
                                <img src="./assets/images/character2.png">
                            </span>
                            <span class="zeit_abgelaufen">Zeit abgelaufen!</span>   
                            <span class="hand-gesture">
                                <img src="./assets/images/anim/click_hand.png">
                            </span> 
                        </div>                      
                    </div>
                </transition>
        
            </div>

            <!-- Nächste Runde -->
            <ul class="list-group list-group-flush">
                <li>
                    <div class="bottom-next-round" v-if="loaded && !timeend">
                        <button type="button" class="btn btn-warning px-4 center pause-btn" @click="newRound()">
                            <span>Nächste Runde </span>
                            <span><b-icon-arrow-right-short scale="1.2" class="icon"></b-icon-arrow-right-short></span>
                        </button>
                    </div>
                </li>
            </ul>
            
            <!-- Hauptmenü -->
            <div v-if="!loaded" class="w-100">
                
                <ul class="list-group list-group-flush">
                    
                    <li class="list-group-item">
                        <div class="loader-logo">
                            <img src="./assets/images/logo/logo2.svg" class="pantomime-logo">
                        </div>
                    </li>
                    
                    <li class="list-group-item">
                        <button type="button" class="btn btn-success wiggle center w-75" @click="newRound()">
                            <div class="p-button">
                                <span>Neues Spiel</span>
                                <span><b-icon-controller scale="1.4"></b-icon-controller></span>
                            </div>
                        </button>
                    </li>

                    <li class="list-group-item">
                        <button type="button" class="btn btn-success center w-75" @click="modalCategories = true; playSound('sounds/click3.mp3')">
                            <div class="p-button">
                                <span>Kategorien</span>
                                <span><b-icon-ui-checks-grid scale="1.3"></b-icon-ui-checks-grid></span>
                            </div>
                        </button>
                    </li>
                    
                    <li class="list-group-item">
                        <button type="button" class="btn btn-danger center w-75" @click="modalHowToPlay = true; playSound('sounds/click3.mp3')">
                            <div class="p-button">
                                <span>Wie wird gespielt</span>
                                <span><b-icon-question-square scale="1.3"></b-icon-question-square></span>
                            </div>
                        </button>
                    </li>
                    
                    <li class="list-group-item">
                        <button type="button" class="btn btn-danger center w-75" @click="modalSettings = true; playSound('sounds/click3.mp3')">
                            <div class="p-button">
                                <span>Einstellungen</span>
                                <span><b-icon-sliders scale="1.3"></b-icon-sliders></span>
                            </div>
                        </button>
                    </li>
                    
                    <li class="list-group-item" v-if="!isProUser">
                        <button type="button" class="btn btn-danger center w-75">
                            <div class="p-button">
                                <span>Vollversion</span>
                                <span><b-icon-key scale="1.3"></b-icon-key></span>
                            </div>
                        </button>   
                    </li>

                    <li>
                        <span class="unlock-pro-text" v-if="!isProUser">* Schalte jetzt Teamplay und alle Kategorien frei</span>
                        <!-- Web Version, Text: App herunterladen um Teamplay und alle Kategorien freizuschalten -->
                    </li>
                   
                    <!-- ******************* MOBILE APP ******************* -->
                    <!-- <li class="list-group-item" v-if="isProUser">
                        <button type="button" class="btn btn-danger center w-75">
                            <div class="p-button">
                                <span>App bewerten</span>
                                <span><b-icon-suit-heart scale="1.3"></b-icon-suit-heart></span>
                            </div>
                        </button>
                    </li> -->
                    <!-- ******************* MOBILE APP ******************* -->

                </ul>
                
            </div>
            
            <!-- MODAL - Einstellungen -->
            <transition name="fade">
                <div id="p-modal" v-if="modalSettings">
                    <div class="settings-menu-main">

                        <p class="settings-entry-main-heading">
                            <b-icon-sliders scale="1.5" class="iconfocus"></b-icon-sliders><span class="px-4">Einstellungen</span>
                        </p>

                        <div class="settings-entry">
                            Spieldauer &nbsp;
                        
                            <div class="btn-group btn-group-toggle" role="group" aria-label="Spieldauer">
                                <button type="button" class="btn btn-outline-secondary" :value="60" :class="[selectedMinutes === 60 ? 'active': '']" @click="selectedMinutes = 60; playSound('sounds/slide.mp3')" >60</button>
                                <button type="button" class="btn btn-outline-secondary" :value="120" :class="[selectedMinutes === 120 ? 'active': '']" @click="selectedMinutes = 120; playSound('sounds/slide.mp3')">120</button>
                                <button type="button" class="btn btn-outline-secondary" :value="180" :class="[selectedMinutes === 180 ? 'active': '']" @click="selectedMinutes = 180; playSound('sounds/slide.mp3')">180</button>
                            </div> 
                        </div>
                        
                        <!-- ******************* MOBILE APP ******************* -->
                        <div class="settings-entry pt-4 ">
                                Sprache &nbsp;
                                <img src="./assets/images/flags/germany.png" class="flag-image">
                        </div>
                        <!-- ******************* MOBILE APP ******************* -->
                        
                        <div class="settings-entry pt-4">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="hasSound">
                                <label class="custom-control-label" for="customSwitch1">Sound</label>
                            </div>
                        </div>

                        <div class="close-menu">
                            <b-icon-x class="pt-1" scale="2" @click="modalSettings = false; playSound('sounds/click3.mp3')"></b-icon-x>
                        </div>
                    </div>
                </div>
            </transition>

            <!-- MODAL - Kategorien -->
            <transition name="fade">
                <div id="p-modal" v-if="modalCategories">
                    <div class="categories-menu">

                        <!-- Loading Categories Swiper -->
                        <categories :allCategories="this.allCategories"></categories>

                        <div class="close-menu-cat">
                            <b-icon-x class="pt-1" scale="2" @click="modalCategories = false; playSound('sounds/click3.mp3')"></b-icon-x>
                        </div>
                    </div>
                </div>
            </transition>

            <!-- MODAL - How To Play -->
            <transition name="fade">
                <div id="how-modal" v-if="modalHowToPlay">
                    <div class="howtoplay-menu">

                        <!-- Loading HowToPlay Swiper -->
                        <how-to-play></how-to-play>

                        <div class="close-menu-cat">
                            <b-icon-x class="pt-1" scale="2" @click="modalHowToPlay = false; playSound('sounds/click3.mp3')"></b-icon-x>
                        </div>
                    </div>
                </div>
            </transition>

            <!-- PRELOADER -->
            <transition name="fade">
                <div class="preloader" v-if="splashScreen" id="p-modal-preloader">
                    <div id="timeend" class="blink_me">
                        <div class="radial_stripes"></div>
                        <span class="quote slide-in-right p-4">
                            <p><span class="pink">Wusstest du schon</span> <br>
                            {{ randomQuote }}
                            </p>
                        </span>
                        <span class="hand-gesture" v-if="!data_loaded"> 
                            <span class="loading_text">{{ loadingText }}</span>
                            <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                        </span> 

                        <span class="hand-gesture" v-if="this.data_loaded"> 
                            <img src="./assets/images/anim/click_hand.png" @click="splashScreen = !splashScreen; playSound('sounds/click3.mp3')">
                        </span> 
                    </div>
                </div>
            </transition>

            <!-- Splash Screen / first Start -->
           <!--  <transition name="fade">
                <div v-if="splashScreen" @click="splashScreen = !splashScreen; playSound('sounds/click3.mp3')" id="p-modal">
           -->       <!-- <div v-if="splashScreen" @click="splashScreen = !splashScreen; playMainLoop('sounds/main_loop.mp3')" id="p-modal"> -->
                   <!--  <div id="timeend" class="blink_me">
                        <div class="radial_stripes"></div>
                        <span class="ende_runde">
                            <img src="./assets/images/character2.png">
                        </span> 

                        <span class="hand-gesture"> 
                            <img src="./assets/images/anim/click_hand.png">
                        </span> 
                      
                    </div>                      
                </div>
            </transition> -->
            
        </div>

    </div>

</template>

<script>
import GameData from "./components/GameData.vue";
import Categories from "./components/Categories.vue";
import HowToPlay from "./components/HowToPlay.vue";

export default {

  components: {
    GameData, Categories, HowToPlay
  },
  
  name: 'App',

  data: function() {
    return {
        message: 'Pantomime Party',
        scharadeData: {},
        seenData: [],
        quotes: [
            "...im Theater der römischen Antike war der Pantomimus eine Art virtuoser Solotänzer. Die römische Pantomime war weit verbreitet, bis das Christentum alle Formen öffentlicher Aufführungen verbot.",
            "...als populäres Gegenstück zum höfischen Ballett wurde im 18. Jahrhundert eine getanzte Form der Commedia dell’arte üblich, die man Pantomime nannte.",
            "...das Aufstreben der Pantomime nach der französischen Revolution hat vor allem mit der strengen Theaterzensur zu tun, die Aufführungen ohne Text, also ohne die Gefahr politischer Äußerungen, stark begünstigte.",
            "...ein wichtiger „Pantomimenmeister“ war etwa Louis Milon am Pariser Théâtre de l’Ambigu-Comique. Von dieser Ballett-Pantomime stammt die sogenannte „englische Pantomime“ ab, die in Joseph Grimaldi (dem Erfinder des Clowns) einen berühmten Interpreten hatte. ",
            "...Marcel Marceau war ein französischer Pantomime. Dem Publikum war er als „Bip“ vertraut, der tragikomische Clown im Ringelhemd mit dem weiß geschminkten Gesicht, dem zerbeulten Seidenhut und der roten Blume.",
            "...die Pantomime entstand, wie andere Theaterformen der Antike in Griechenland. Erste Formen der Pantomime vermutet man bei den Dionysischen Festspielen."           
        ],
        randomQuote: "",

        isActive: false,
        currentItems: [],
        allCategories: null,
        loaded: false,
        minutes: 120,
        selectedMinutes: 120,
        countdown: null,
        timeend: false,
        score: 0,
        teamName: "",
        showWords: true,
        checked: false,
        checked2: false,
        checked3: false,
        firstRound: 0,
        hasSound: true,
        isProUser: false,

        loadingText: "...loading",

        preloader: false,
        data_loaded: false,

        modalMainMenu: false,
        modalEnde: false,
        modalGameStart: false,
        modalSettings: false,
        modalCategories: false,
        modalHowToPlay: false,
        splashScreen: true,

        hand1: false,
        hand2: false,
        hand3: false,
        };
    },

    mounted(){

        console.log("Pantomime Party developed by Oliver Borner.")

        // Random Quote
        this.randomQuote = this.quotes[Math.floor(Math.random()*this.quotes.length)]

        // check app status
        this.isProUser = this.$refs.gameDataComponent.getProStatus();

        setTimeout(() => {  this.loadingText = "...check Userstatus"; }, 1000);
        setTimeout(() => {  this.loadingText = "...lade Sounds"; }, 2000);
        setTimeout(() => {  this.loadingText = "...lade Grafiken"; }, 3000);

        // Alle Kategorien für den Swiper
        this.allCategories = this.$refs.gameDataComponent.fetchCategories();

        setTimeout(() => {  this.loadingText = "...lade Kategorien"; }, 4000);
        setTimeout(() => {  this.loadingText = "...lade Wörterdatenbank"; }, 5000);

        setTimeout(() => {  this.data_loaded = true; }, 6000);
       
      
	},

	methods:{

        backToMainMenu(){
            this.stopTimer();
            this.checked = false;
            this.checked2 = false;
            this.checked3 = false;
            this.score = 0;
            this.firstRound = 0;
            this.seenData = [];
            this.minutes = this.selectedMinutes;
            this.modalMainMenu = false;
            this.modalEnde = false;
            this.modalGameStart = false;
            this.modalSettings = false;
            this.modalCategories = false;
            this.modalHowToPlay = false,
            this.loaded = false;
            this.isActive = false;
        },

        playSound (sound) {
            if(this.hasSound){
                if(sound) {
                    var audio = new Audio(sound, {formats: [ "mp3" ], preload: true});
                    audio.play();
                }
            }
        },

        playMainLoop(sound){
            // DOM Exception error -> Solution: Modal mit Character -> Start Game / Spiel Starten
            let myAudio;

            if(this.hasSound){
                myAudio = new Audio(sound, {formats: [ "mp3" ], preload: true}); 

                if (typeof myAudio.loop == 'boolean')
                {
                    myAudio.loop = true;
                }
                else
                {
                    myAudio.addEventListener('ended', function() {
                        this.currentTime = 0;
                        this.play();
                    }, false);
                }
   
                myAudio.play();

            } else {
                myAudio.loop = false;
            } 

        },

        startTimer(){
            let seconds = this.minutes // initial time
            let et = this.$refs.elaspedTime
            et.style.width = '0%'

            this.countdown = setInterval(() => {

                if(!this.pauseGame) {

                    this.minutes--;
                    this.playSound('sounds/tick.mp3');
                }

                et.style.width = ((seconds - this.minutes) * 100) / seconds + '%'

                if (this.minutes === 0) {

                    this.timeend = true;

                    // Play Sound timeend
                    this.playSound('sounds/timeend.mp3');

                    this.stopTimer();
                    
                }


            }, 1000);
        },

        stopTimer() {

            clearInterval(this.countdown);
            
        },

        newRound(){

            this.modalCategories = false;
            this.minutes = this.selectedMinutes;
            /* this.minutes = 60; */
            this.firstRound++;

            // Animation Handling
            if (this.firstRound > 1) {
                var element = document.getElementById("wordsout");
                var firstword = document.getElementById("firstword");
                var secondword = document.getElementById("secondword");
                var thirdword = document.getElementById("thirdword");
                
                element.classList.add("swing-out-top-bck");
                firstword.classList.remove("slide-in-left");
                secondword.classList.remove("slide-in-right");
                thirdword.classList.remove("slide-in-bottom");

                let self = this;

                window.setTimeout(function () {   
                    let category = "all";
                    element.classList.remove("swing-out-top-bck");  
                    firstword.classList.add("slide-in-left");
                    secondword.classList.add("slide-in-right");
                    thirdword.classList.add("slide-in-bottom");    

                    self.getNewItems(category);

                }, 400); 
            }

            this.score += this.currentScore;

            this.isActive = true;
            this.timeend = false;
            this.showWords = true;
            this.checked = false;
            this.checked2 = false;
            this.checked3 = false;

            this.stopTimer();
            this.startTimer();
            this.currentItems = [];
            
            if (this.firstRound <= 1) {

                this.stopTimer();

                // Play Hand Counting Animation
                this.modalGameStart = true;
                
                setTimeout(() => {  this.hand1 = true; this.playSound('sounds/count2.mp3') }, 200);
                setTimeout(() => {  this.hand1 = false;  }, 800);

                setTimeout(() => {  this.hand2 = true; this.playSound('sounds/count2.mp3') }, 1400);
                setTimeout(() => {  this.hand2 = false;  }, 2000);

                setTimeout(() => {  this.hand3 = true; this.playSound('sounds/count2.mp3') }, 2500);
                setTimeout(() => {  this.hand3 = false;  this.modalGameStart = false; this.startTimer(); this.playSound('sounds/go.mp3') }, 3500);

               
                // frische Daten mit allen Einstellungen
               
                // dont mutate copying object
                this.scharadeData = Object.assign({}, this.$refs.gameDataComponent.fetchData(), this.scharadeData);
 
                let category;
               

                // Kategorie - Auswahl
                let playDataSetArray = [];

                // wenn kein Kategorie ausgewählt
                let hasNoCategories = false;
                hasNoCategories = Object.entries(this.allCategories).every(val => val[1][1].active === false);

                if(hasNoCategories){
                    Object.entries(this.allCategories).forEach(val => {
                        if(!val[1][1].locked) {
                            val[1][1].active = true;
                        }
                    });
                }

                // eine oder mehrere Kategorien
                for (let i = 0; i < this.allCategories.length; i++) {
                    if(this.scharadeData[this.allCategories[i][0]]["locked"] !== true){
                        if(this.scharadeData[this.allCategories[i][0]]["active"] === true) {
                            playDataSetArray.push(this.scharadeData[this.allCategories[i][0]]["words"]);
                        }  
                    } 
                }
                
                this.scharadeData = {};

                if (playDataSetArray.length > 1) {
                    this.scharadeData["all"] = playDataSetArray.flat();
                } 
                else {
                    this.scharadeData["all"] = playDataSetArray.flat();
                }
                
                category = "all";
              

                this.getNewItems(category);
                
            }
            
        },

        getNewItems(category) {
            this.playSound('sounds/monkey.mp3');

            let item1 = "";
            let item2 = "";
            let item3 = "";

            // pick as long as there are no more dupes
            while(item1 === item2 || item1 === item3 || item2 === item3){
                item1 = this.getRandomItem(category);
                item2 = this.getRandomItem(category);
                item3 = this.getRandomItem(category);
            }
                    
            this.currentItems.push(item1, item2, item3);

            this.seenData.push(item1, item2, item3);

            // remove selected values
            let index = this.scharadeData[category].indexOf(item1);
            if (index > -1) {
                this.scharadeData[category].splice(index, 1);
            }
            index = this.scharadeData[category].indexOf(item2);
            if (index > -1) {
                this.scharadeData[category].splice(index, 1);
            }
            index = this.scharadeData[category].indexOf(item3);
            if (index > -1) {
                this.scharadeData[category].splice(index, 1);
            }

            // Ende
            if (this.scharadeData[category].length < 3) {
                this.scharadeData[category] = this.seenData;
                this.seenData = [];

                this.modalEnde = true;
            }
            else {
                this.loaded = true;
            }

        },

		// Zufällige Worte wählen	
        getRandomItem(category) {
            return this.scharadeData[category][Math.floor(Math.random() * this.scharadeData[category].length)];
        }
				
    },
    computed:{
        currentScore(){
            if (this.checked && this.checked2 && this.checked3) return 3;
            if (this.checked && this.checked2) return 2;
            if (this.checked2 && this.checked3) return 2;
            if (this.checked && this.checked3) return 2;
            if (this.checked || this.checked2 || this.checked3) return 1;

            return 0;
        },

        // Timer anhalten
        pauseGame() {

            if (this.checked && this.checked2 && this.checked3) {

                const indicateNext = document.querySelector('.pause-btn');
                indicateNext.classList.add('button-glow');

                // play sound hey
                this.playSound('sounds/ukulele.mp3');

                return true;
            }

            const indicateNext = document.querySelector('.pause-btn');
            indicateNext.classList.remove('button-glow');

            return false
        }, 
    }
 
}
</script>

<style scoped lang="scss"></style>